import { ROUTES } from 'constants/routes';
import { useFetchReportNotificationsCount } from 'hooks/useFetchReportNotificationsCount';
import { useUserStore } from 'stores/user';
import { getSidebarRoutes } from 'utils/nav';

export const usePendingNotificationsCount = (): number => {
  const user = useUserStore(state => state.user);
  const canSeeNotifications = getSidebarRoutes(user?.type, user?.role).some(
    route => route.href === ROUTES.NOTIFICATIONS
  );
  const { data = 0 } = useFetchReportNotificationsCount(canSeeNotifications);
  return data;
};
